import { ApolloClient } from '@apollo/client';
import AsyncStorage from '@react-native-community/async-storage';
import { useValues } from '@redlink/assets/values';
import { setContext } from '@apollo/client/link/context';
import { progressiveFetch } from './progressiveFetch';
import { cache } from './cache';
const { createUploadLink } = require('apollo-upload-client');

export const useApolloClient = () => {
  const { constants } = useValues();

  const httpLink = createUploadLink({
    uri: constants.apiUrl,
    fetch: progressiveFetch,
  });

  const asyncAuthLink = setContext(
    ({ headers }) =>
      new Promise((success, fail) => {
        const clientReferrer = document.referrer;
        AsyncStorage.getItem('@token').then((token) => {
          success({
            headers: {
              ...headers,
              ...(token && { authorization: `Bearer ${token}` }),
              ...(clientReferrer && { clientReferrer }),
            },
          });
        });
      })
  );

  const client = new ApolloClient({
    link: asyncAuthLink.concat(httpLink),
    cache,
  });

  return { client };
};
